const ACTIVE_CHECKOUT_STATUSES = new Set([
  'checked-out',
  'outbound-label',
  'outbound-in-transit',
  'with-borrower',
  'return-initiated',
  'return-in-transit',
])

const ROADMAP_STATUSES = new Set([
  'reserved',
  'outbound_label',
  'carrier_accepted',
  'outbound_in_transit',
  'out_for_delivery',
  'with_borrower',
  'return_initiated',
  'return_carrier_scan',
  'return_in_transit',
  'received',
  'checked_in',
])

export function normalizeStatus(rawStatus: unknown): string {
  return String(rawStatus || '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/_/g, '-')
    .trim()
}

export function isActiveCheckoutStatus(rawStatus: unknown): boolean {
  return ACTIVE_CHECKOUT_STATUSES.has(normalizeStatus(rawStatus))
}

export function isMockSerial(rawSerial: unknown): boolean {
  const serial = String(rawSerial || '').trim().toLowerCase()
  if (!serial) return false
  return serial.startsWith('test-') || serial.startsWith('mock-') || serial.startsWith('demo-')
}

function mapShipmentStatusToRoadmap(rawStatus: unknown): string {
  const s = normalizeStatus(rawStatus)
  if (!s) return ''
  if (s.includes('label')) return 'outbound_label'
  if (s.includes('accept')) return 'carrier_accepted'
  if (s.includes('out-for-delivery')) return 'out_for_delivery'
  if (s.includes('return') && s.includes('transit')) return 'return_in_transit'
  if (s.includes('return') && s.includes('scan')) return 'return_carrier_scan'
  if (s.includes('transit')) return 'outbound_in_transit'
  if (s.includes('delivery')) return 'with_borrower'
  return ''
}

export function roadmapStatusFromSources(rawCheckoutStatus: unknown, shipments: any[]): string {
  const normalized = normalizeStatus(rawCheckoutStatus)
  const roadmapCandidate = normalized.replace(/-/g, '_')
  if (ROADMAP_STATUSES.has(roadmapCandidate)) return roadmapCandidate

  // `checked-out` means active checkout, but may not have shipping events yet.
  if (normalized === 'checked-out') return 'checked_out'
  if (normalized === 'reserved') return 'reserved'

  const outbound = (shipments || []).find((s: any) => s?.type === 'outbound')
  const fromShipment = mapShipmentStatusToRoadmap(outbound?.status)
  if (fromShipment) return fromShipment

  return 'reserved'
}

